module.exports = __webpack_public_path__ + "static/img/applewood.f8b87e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/applewood.png
// module id = EHw3
// module chunks = 1